import type { FC } from 'react';
import { createPortal } from 'react-dom';
import type { PopperProps } from './types';

export * from './types';

export const Popper: FC<PopperProps> = (props) => {
  const { open = false, setPopperElement, popperProps, children, ...rest } = props;

  const PopperPortal = typeof document !== 'undefined' && document.getElementById('popper-root');

  if (!PopperPortal) {
    return null;
  }

  return createPortal(
    open && (
      <div
        {...rest}
        ref={setPopperElement}
        style={popperProps.styles.popper}
        {...popperProps.attributes.popper}
      >
        {children}
      </div>
    ),
    PopperPortal,
  );
};
